import { render } from "./HiConfirm.vue?vue&type=template&id=27458b3b"
import script from "./HiConfirm.vue?vue&type=script&lang=js"
export * from "./HiConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__